module.exports = {"closeButtonText":"إغلاق","thumbNailAlt":"معاينة الصورة","next":"الصفحة التالية","previous":"الصفحة السابقة","addNote":"إضافة ملاحظة..."}


//////////////////
// WEBPACK FOOTER
// ./translations/ar.json
// module id = 29
// module chunks = 0